import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appFormControlValidation]'
})
export class FormControlValidationDirective {

    constructor(
        private el: ElementRef,
        private ngControl: NgControl,
        private renderer: Renderer2
    ) { }

    @HostListener('input', ['$event.target'])
    public onInputChange(target: any) {
        // Used for input element
        if (target.localName === 'input') {
            this.checkAndAddInvalidClass();
            this.checkAndRemoveInvalidClass();
        }
    }

    @HostListener('change', ['$event'])
    public onSelectChange(target: any) {
        // Used for ng-select element
        if (!target.localName) {
            this.checkAndAddInvalidClass();
            this.checkAndRemoveInvalidClass();
        }
    }

    @HostListener('bsValueChange', ['$event'])
    public onSelectChanges(target: any) {
        // Used for bsdatepicker element
        setTimeout(() => {
            if (target) {
                this.checkAndAddInvalidClass();
                this.checkAndRemoveInvalidClass();
            }
        });
    }

    @HostListener('focus', ['$event.target'])
    public onFocus(target: any) {
        if (target.localName === 'input') {
            this.checkAndAddInvalidClass();
        }
    }

    @HostListener('blur', ['$event.target'])
    public onBlur(target: any) {
        if (target.localName === 'input') {
            this.checkAndRemoveInvalidClass();
        }
    }

    private isInputGroupText(element: Element | null | undefined): element is Element {
        return !!element?.classList?.contains('input-group-text');
    }

    private toggleInputGroupIconInvalid(element: HTMLInputElement, add: boolean) {
        const inputPrependIconElement = element.previousSibling?.firstChild as Element | null;
        if (this.isInputGroupText(inputPrependIconElement)) {
            if (add && !inputPrependIconElement.classList.contains('is-invalid')) {
                this.renderer.addClass(inputPrependIconElement, 'is-invalid');
            } else if (!add && inputPrependIconElement.classList.contains('is-invalid')) {
                this.renderer.removeClass(inputPrependIconElement, 'is-invalid');
            }
        }

        const inputAppendIconElement = element.nextSibling?.firstChild as Element | null;
        if (this.isInputGroupText(inputAppendIconElement)) {
            if (add && !inputAppendIconElement.classList.contains('is-invalid')) {
                this.renderer.addClass(inputAppendIconElement, 'is-invalid');
            } else if (!add && inputAppendIconElement.classList.contains('is-invalid')) {
                this.renderer.removeClass(inputAppendIconElement, 'is-invalid');
            }
        }
    }

    private checkAndAddInvalidClass() {
        if (!this.ngControl.control.valid) {
            const element = this.el.nativeElement as HTMLElement;
            if (element.localName === 'input') {
                if (!element.classList.contains('is-invalid')) {
                    this.renderer.addClass(element, 'is-invalid');
                    this.toggleInputGroupIconInvalid(element as HTMLInputElement, true);
                }
            } else if (element.localName === 'ng-select') {
                const selectElement = element.firstChild as HTMLElement | null;
                if (selectElement?.classList && !selectElement.classList.contains('is-invalid')) {
                    this.renderer.addClass(selectElement, 'is-invalid');
                }
            }
        }
    }

    private checkAndRemoveInvalidClass() {
        if (this.ngControl.control.valid) {
            const element = this.el.nativeElement as HTMLElement;
            if (element.localName === 'input') {
                if (element.classList.contains('is-invalid')) {
                    this.renderer.removeClass(element, 'is-invalid');
                    this.toggleInputGroupIconInvalid(element as HTMLInputElement, false);
                }
            } else if (element.localName === 'ng-select') {
                const selectElement = element.firstChild as HTMLElement | null;
                if (selectElement?.classList?.contains('is-invalid')) {
                    this.renderer.removeClass(selectElement, 'is-invalid');
                }
            }
        }
    }

}
